import { FrameName } from "../config";
import AbstractSalvageableTileEntity from "./AbstractSalvageableTileEntity";

class DamagedMillSalvageableTileEntity extends AbstractSalvageableTileEntity {
	public static readonly frameName = FrameName.DAMAGED_MILL;
}

export default DamagedMillSalvageableTileEntity;
